<template>
  <div class="lamp paper" :class="pageStatus"></div>
</template>

<script>
export default {
    name: 'Pages',
    props: {
        pages: {
            type: Number
        },
        isOnline: {
            type: Boolean
        }
    },

    computed: {
        pageStatus () {
            if (!this.isOnline) {
                return 'nocube';
            }
            if (this.pages < 0) {
                return 'error';
            } else if (this.pages < 50) {
                return 'low';
            } else {
                return 'ok';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.lamp {
  height: 20px;
  width: 20px;

  border-radius: 50%;
  display: inline-block;
  &.online {
    background-color: green;
  }
  &.paper {
    border-radius: 0;
    background-color: #ddd;

    &.error {
      background-color: red;
    }
    &.low {
      background-color: #eac800;
    }
    &.ok {
      background-color: green;
    }
    &.nocubes {
      background-color: gainsboro;
    }
  }
}
</style>
